"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdAdd = require("@react-icons/all-files/md/MdAdd");

var _MdRemove = require("@react-icons/all-files/md/MdRemove");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _RatioBox = _interopRequireDefault(require("../RatioBox/RatioBox.index"));

var _Quantity = require("./Quantity.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Quantity = function Quantity(_ref) {
  var className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      initialQuantity = _ref.quantity,
      warning = _ref.warning,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)(initialQuantity),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      quantity = _useState2[0],
      setQuantity = _useState2[1];

  var updateQuantity = function updateQuantity(val) {
    var value = val || min;
    if (value > max) value = max;
    if (value < min) value = min;
    value = value === 0 ? '0' : value.toString().replace(/^0+/, '');
    setQuantity(value);
    onChange(value);
  };

  var handlePaste = function handlePaste(e) {
    e.stopPropagation();
    e.preventDefault();
    var clipboardData = e.clipboardData || window.clipboardData;
    var pastedData = clipboardData.getData('Text');
    var isNumber = !isNaN(pastedData);

    if (isNumber) {
      updateQuantity(pastedData);
    }
  };

  var handleOnChange = function handleOnChange(e) {
    var value = e.target.value;
    value = value === '' ? min : parseInt(value, 10);
    updateQuantity(value);
  };

  var handleQuantity = function handleQuantity(action) {
    var qty = parseInt(quantity, 10);

    switch (action) {
      default:
      case 'add':
        updateQuantity(qty + 1);
        break;

      case 'subtract':
        updateQuantity(qty - 1);
        break;
    }
  };

  var maxLength = (0, _react.useMemo)(function () {
    return max && max.toString().length;
  }, [max]);
  var minusDisabled = (0, _react.useMemo)(function () {
    return +quantity === min;
  }, [min, quantity]);
  var plusDisabled = (0, _react.useMemo)(function () {
    return +quantity === max;
  }, [max, quantity]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, label && /*#__PURE__*/_react["default"].createElement(_Quantity.StyledLabel, {
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement(_Quantity.StyledQuantity, null, /*#__PURE__*/_react["default"].createElement(_Quantity.StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_RatioBox["default"], null, /*#__PURE__*/_react["default"].createElement(_Quantity.StyledButton, {
    type: "button",
    onClick: function onClick() {
      return handleQuantity('subtract');
    },
    disabled: minusDisabled
  }, /*#__PURE__*/_react["default"].createElement(_MdRemove.MdRemove, null)))), /*#__PURE__*/_react["default"].createElement(_Quantity.StyledInput, {
    id: id,
    inputMode: "numeric",
    max: max,
    maxLength: maxLength,
    min: min,
    onChange: handleOnChange,
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    onPaste: handlePaste,
    type: "number",
    value: quantity,
    warning: warning
  }), /*#__PURE__*/_react["default"].createElement(_Quantity.StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_RatioBox["default"], null, /*#__PURE__*/_react["default"].createElement(_Quantity.StyledButton, {
    type: "button",
    onClick: function onClick() {
      return handleQuantity('add');
    },
    disabled: plusDisabled
  }, /*#__PURE__*/_react["default"].createElement(_MdAdd.MdAdd, null))))));
};

Quantity.defaultProps = {
  className: '',
  label: undefined,
  max: 9999,
  min: 0,
  quantity: 0,
  warning: false,
  onChange: function onChange() {}
};
Quantity.propTypes = {
  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Quantity field unique identifier */
  id: _propTypes.string.isRequired,

  /** Label of the quantity input */
  label: _propTypes.string,

  /** Maximum number to be selected */
  max: _propTypes.number,

  /** Minimum number to be selected */
  min: _propTypes.number,

  /** Initial value of the quantity box */
  quantity: _propTypes.number,

  /** Display warning status */
  warning: _propTypes.bool,

  /** Function to be called when the quantity value is changed */
  onChange: _propTypes.func
};
Quantity.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Quantity",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Label of the quantity input",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "max": {
      "defaultValue": {
        "value": "9999",
        "computed": false
      },
      "description": "Maximum number to be selected",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "min": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "Minimum number to be selected",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "quantity": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "Initial value of the quantity box",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "warning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Display warning status",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when the quantity value is changed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "id": {
      "description": "Quantity field unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Quantity;
exports["default"] = _default;